export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 py-8 text-center text-zinc-500 text-sm">

      <p>
       © 2026 HiiManish. All Rights Reserved.
      </p>

    </footer>
  );
}